export const $me = async ({ headers }) => {
 try {
   const response = await fetch('https://pre-dev.api.forgd-test.com/api/users/me', { headers })
   if (!response.ok) {
     const e = new Error('Failed to fetch /me request.')
     e.statusCode = response.status
     e.path = response.url
     throw e
   }
   const result = await response.json()
   return result
 } catch(err) {
   throw err
 }
}